import { gql } from 'apollo-boost';

const acceptEulaMutation = gql`
  mutation {
    user {
      acceptEula {
        id
        eulaAccepted
        eulaAcceptedAtUtc
      }
    }
  }
`;
export const acceptEula = async ApolloClient => {
  const { eulaAccepted } = await ApolloClient.mutate({
    mutation: acceptEulaMutation
  });

  return eulaAccepted;
};

export default { acceptEula };
